jQuery(document).ready(function($) {

    let verifyTimeoutForm = null;
    let fvVerify = null;
    /**
     *  Verify on Timeout Form Validation
    */
    verifyTimeoutForm = document.getElementById('verifyTimeoutForm');
    let verifyTimeoutFormFirstErrorField = null;
    if(verifyTimeoutForm) {
        fvVerify = FormValidation.formValidation(
            verifyTimeoutForm,
            {
                fields: {
                    email: {
                        validators: {
                            notEmpty: {
                                message: 'This field is required',
                            },
                        }
                    },
                    dob_month: {
                        selector: '.js-dob-month',
                        validators: {
                            callback: {
                                message: 'The month field is required',
                                callback: function callback($field) {
                                    if($field.value.length > 0) {
    
                                        return validateDobFields(verifyTimeoutForm);
    
                                    }
                                    return false;
                                }
                            }
                        }
                    },
                    dob_day: {
                        selector: '.js-dob-day',
                        validators: {
                            callback: {
                                message: 'The day field is required',
                                callback: function callback($field) {
    
                                    if($field.value.length > 0) {
    
                                        return validateDobFields(verifyTimeoutForm);
    
                                    }
                                    return false;
                                }
                            }
                        }
                    },
                    dob_year: {
                        selector: '.js-dob-year',
                        validators: {
                            callback: {
                                message: 'The year field is required',
                                callback: function callback($field) {
    
                                    if($field.value.length > 0) {
    
                                        return validateDobFields(verifyTimeoutForm);
    
                                    }
                                    return false;
                                }
                            }
                        }
                    },
                    ssn4: {
                        validators: {
                            notEmpty: {
                                message: 'This field is required',
                            },
                            stringLength: {
                                min: 4,
                                message: 'The field must be 4 digits long',
                            }
                        }
                    },
                },
                plugins: {
                    bootstrap5: new FormValidation.plugins.Bootstrap5(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    trigger: new FormValidation.plugins.Trigger({
                        event: {
                            ssn_digits: 'blur',
                            dob_month: 'blur',
                            dob_day: 'blur',
                            dob_year: 'blur',
                            email: 'blur'
                        }
                    }),
                      // icon: new FormValidation.plugins.Icon({
                      //     valid: 'fa fa-check',
                      //     invalid: 'fa fa-times',
                      //     validating: 'fa fa-refresh',
                      // }),
                }
            }
        ).on('core.form.valid', function() {
 
            var dob = verifyTimeoutForm.querySelector('[name=dob]');

            if(dob) {
                fixDobInput(verifyTimeoutForm);
            }

            blockPage();

            verifyTimeoutForm.querySelector('[type="submit"]').disabled = true;
            
            $(verifyTimeoutForm).submit();
      
        }).on('plugins.message.displayed', function(e) {
            if (verifyTimeoutFormFirstErrorField == null) {
                verifyTimeoutFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(verifyTimeoutFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;
  
            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");
  
            verifyTimeoutFormFirstErrorField = null;
        });
    }

    /**
     *  Search Form Validation
    */
    const searchAppForm = document.getElementById('searchAppForm');
    let searchAppFormFirstErrorField = null;
    if(searchAppForm) {
        const fvSearch = FormValidation.formValidation(
            searchAppForm,
            {
                fields: {
                    email: {
                        validators: {
                            notEmpty: {
                                message: 'This field is required',
                            },
                        }
                    },
                    ssn4: {
                        validators: {
                            notEmpty: {
                                message: 'This field is required',
                            },
                            stringLength: {
                                min: 4,
                                message: 'The field must be 4 digits long',
                            }
                        }
                    },
                },
                plugins: {
                    bootstrap5: new FormValidation.plugins.Bootstrap5(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    trigger: new FormValidation.plugins.Trigger({
                        event: {
                            email: 'blur',
                            ssn4: 'blur',
                        }
                    }),
                    // icon: new FormValidation.plugins.Icon({
                    //     valid: 'fa fa-check',
                    //     invalid: 'fa fa-times',
                    //     validating: 'fa fa-refresh',
                    // }),
                }
            }
        ).on('core.form.valid', function() {

            searchAppForm.querySelector('[type="submit"]').disabled = true;
            blockPage();

            $(searchAppForm).submit();
    
        }).on('plugins.message.displayed', function(e) {
            if (searchAppFormFirstErrorField == null) {
                searchAppFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(searchAppFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            searchAppFormFirstErrorField = null;
        });
    }

    /**
     *  Activate Form Validation
    */
    const activateCardForm = document.getElementById('activateCardForm');
    let activateCardFormFirstErrorField = null;
    if(activateCardForm) {
        const fvActivate = FormValidation.formValidation(
            activateCardForm,
            {
                fields: {
                    card_num: {
                        validators: {
                            callback: {
                            message: 'The card number is required',
                            callback: function callback($field) {
                                var value = $.trim($field.value);
                                var stripedValue = value.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }
                                if (stripedValue.length == 16) {
                                    // Check for valid 
                                    // if(stripedValue.substr(0,6) !== '544303') {
                                    //     return {
                                    //         valid: false,
                                    //         message: 'Invalid entry. The card number is 16 digits beginning with 5443.'
                                    //     };
                                    // }
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                        }
                    },
                    ssn4: {
                        validators: {
                            callback: {
                                message: 'The social security number is required',
                                callback: function callback($field) {
                                    var ssn = $.trim($field.value);
                                    var stripedValue = ssn.replace(/\D/g, '');
                                    if (stripedValue.length == 0) {
                                        return {
                                            valid: false,
                                            message: 'The social security number is required'
                                        };
                                    }
                                    if (stripedValue.length == 4) {
                                        return {
                                            valid: true,
                                            message: ''
                                        };
                                    }
    
                                    return {
                                        valid: false
                                    };
                                }
                            }
                        }
                    },
                    phone: {
                        validators: {
                            notEmpty: {
                                message: 'The phone number is required',
                            },
                        }
                    },
                },
                plugins: {
                    bootstrap5: new FormValidation.plugins.Bootstrap5(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    trigger: new FormValidation.plugins.Trigger({
                        event: {
                            card_num: 'blur',
                            ssn4: 'blur',
                            phone: 'blur'
                        }
                    }),
                    // icon: new FormValidation.plugins.Icon({
                    //     valid: 'fa fa-check',
                    //     invalid: 'fa fa-times',
                    //     validating: 'fa fa-refresh',
                    // }),
                }
            }
        ).on('core.form.valid', function() {

            activateCardForm.querySelector('[type="submit"]').disabled = true;
            blockPage();

            $(activateCardForm).submit();
    
        }).on('plugins.message.displayed', function(e) {
            if (activateCardFormFirstErrorField == null) {
                activateCardFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(activateCardFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            activateCardFormFirstErrorField = null;
        });
    }

    $("#activateCardForm input[name='card_num']").on('keydown', function() {
        var value = $.trim($(this).val());
        var stripedValue = value.replace(/\D/g, '');
        if (stripedValue.substr(0, 4) == "5264") {
          $(".page.activate .fiserv-msg").addClass("alert-warning");
          $(this).addClass("is-invalid");
        } else {
          $(".page.activate .fiserv-msg").removeClass("alert-warning");
          $(this).removeClass("is-invalid");
        }
    });

    /**
     *  Fund Form Validation
    */
    const fundingLookupForm = document.getElementById('fundingLookupForm');
    let fundingLookupFormFirstErrorField = null;
    if(fundingLookupForm) {
        const fvFundLookup = FormValidation.formValidation(
            fundingLookupForm,
            {
                fields: {
                    account_number: {
                        validators: {
                            callback: {
                            message: 'The card number is required',
                            callback: function callback($field) {
                                var value = $.trim($field.value);
                                var stripedValue = value.replace(/\D/g, '');
                                if (stripedValue.length == 0) {
                                    return {
                                        valid: false,
                                        message: 'The card number is required'
                                    };
                                }
                                if (stripedValue.length == 16) {
                                    // Check for valid 
                                    if(stripedValue.substr(0,6) !== '544303') {
                                        return {
                                            valid: false,
                                            message: 'Invalid entry. The card number is 16 digits beginning with 5443.'
                                        };
                                    }
                                    return {
                                        valid: true,
                                        message: ''
                                    };
                                }

                                return {
                                    valid: false
                                };
                            }
                        }
                        }
                    },
                },
                plugins: {
                    bootstrap5: new FormValidation.plugins.Bootstrap5(),
                    submitButton: new FormValidation.plugins.SubmitButton(),
                    trigger: new FormValidation.plugins.Trigger({
                        event: {
                            account_number: 'blur'
                        }
                    })
                }
            }
        ).on('core.form.valid', function() {

            fundingLookupForm.querySelector('[type="submit"]').disabled = true;
            blockPage();

            $(fundingLookupForm).submit();
    
        }).on('plugins.message.displayed', function(e) {
            if (fundingLookupFormFirstErrorField == null) {
                fundingLookupFormFirstErrorField = e.element;
            }
        }).on('core.form.invalid', function(e) {
            var elementWrapper = $(fundingLookupFormFirstErrorField).closest('.row');
            var elementPosition = elementWrapper.offset().top;

            $([document.documentElement, document.body]).animate({
                scrollTop: elementPosition
            }, 50, "linear");

            fundingLookupFormFirstErrorField = null;
        });
    }

    /**
     * Selectize
     */
    if(verifyTimeoutForm) {
        // DOB Selectize 
        var $selectMonthDob = $("#verifyTimeoutForm select[name='dob_month']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var $selectDayDob = $("#verifyTimeoutForm select[name='dob_day']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });
        var $selectYearDob = $("#verifyTimeoutForm select[name='dob_year']").selectize({
            onInitialize: function() {
                this.$control_input.attr('inputmode', 'none');
            }
        });

        if($selectDayDob[0]) {
            var selectDayDob = $selectDayDob[0].selectize;
            var selectMonthDob = $selectMonthDob[0].selectize;
            var selectYearDob = $selectYearDob[0].selectize;
            var $month = verifyTimeoutForm.querySelector('[name="dob_month"]');
            var $day = verifyTimeoutForm.querySelector('[name="dob_day"]');
            var $year = verifyTimeoutForm.querySelector('[name="dob_year"]');

            selectMonthDob.on('change', function(e) {

                var days = moment($selectMonthDob[0].value, "M").daysInMonth();
                days = days == 28 ? 29 : days;
        
                switch(days) {
                    case 30:
                        selectDayDob.addOption({ text: '30', value: 30 });
                        selectDayDob.removeOption('31');
                    break;
                    case 29:
                    case 28:
                        selectDayDob.removeOption('31');
                        selectDayDob.removeOption('30');
                    break;
                    default:
                        selectDayDob.addOption({ text: '30', value: 30 });
                        selectDayDob.addOption({ text: '31', value: 31 });
                }
        
                fvVerify.revalidateField('dob_month');
                if ($day.value.length > 0) {
                    fv2.revalidateField("dob_day");
                }
                if ($year.value.length > 0) {
                    fv2.revalidateField("dob_year");
                }
            });
        
            selectDayDob.on('change', function(e) {
                fvVerify.revalidateField('dob_day');
                if ($year.value.length > 0) {
                    fv2.revalidateField("dob_year");
                }
                if ($month.value.length > 0) {
                    fv2.revalidateField("dob_month");
                }
            });
        
            selectYearDob.on('change', function(e) {
                fvVerify.revalidateField('dob_year');
                if ($month.value.length > 0) {
                    fv2.revalidateField("dob_month");
                }
                if ($day.value.length > 0) {
                    fv2.revalidateField("dob_day");
                }
            });
        }
    }

    // end DOB Selectize

    /** HELPER METHODS */
    function fixDobInput(form) {
        var month, day, year, dob;

        month = form.querySelector('[name="dob_month"]').value;
        day = form.querySelector('[name="dob_day"]').value;
        year = form.querySelector('[name="dob_year"]').value;
        dob = month + '/' + day + '/' + year;
        form.querySelector('[name="dob"]').value = dob;

        return;
    }

    function validateDobFields(form) {
        var month, day, year, dob;

        month = form.querySelector('[name="dob_month"]').value;
        day = form.querySelector('[name="dob_day"]').value;
        year = form.querySelector('[name="dob_year"]').value;

        if(month.length > 0 && day.length > 0 && year.length > 0) {
            var yearsOfAge = moment().diff(moment(year+'-'+month+'-'+day, "YYYY-MM-DD"), 'years');
            var $elementWrapper, $errorWrapper, message;

            $elementWrapper = $('#verifyTimeoutForm [name="dob_year"]').closest('.row');
            $errorWrapper = $('#verifyTimeoutForm .allowed-age-error').first();
            
            if(yearsOfAge < 19) {
                // Validate age for AL & NE
                if($('#verifyTimeoutForm [name=_state]').length > 0) {
                    var stateAbbr = $('#verifyTimeoutForm [name=_state]').val();
                    var states = ['AL', 'NE'];
                    if(yearsOfAge < 19 && states.includes(stateAbbr.toUpperCase())) {
                        message = 'You must be 19 years or older to be eligible';
                        $elementWrapper.find('.fv-plugins-message-container.invalid-feedback').addClass('d-none');
                        $errorWrapper.html(message).removeClass('d-none');
                        return {
                            valid: false,
                            message: ''
                        };
                    }
                }
            }
            
            if(yearsOfAge < 18) {
                message = 'You must be 18 years or older to be eligible';
                $elementWrapper.find('.fv-plugins-message-container.invalid-feedback').addClass('d-none');
                $errorWrapper.html(message).removeClass('d-none');
                return {
                    valid: false,
                    message: ''
                };
            }

            $elementWrapper.find('.fv-plugins-message-container.invalid-feedback').removeClass('d-none');
            $errorWrapper.addClass('d-none');


            setTimeout(() => {
                fvVerify.revalidateField('dob_month');
                fvVerify.revalidateField('dob_day');
                fvVerify.revalidateField('dob_year');
            }, 100);
        }
        
        return {
            valid: true,
            message: ''
        };
    }

    function blockPage() {
        $.LoadingOverlay("show", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function unblockPage() {
        $.LoadingOverlay("hide", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function blockElement(el) {
        $(el).LoadingOverlay("show", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }

    function unblockElement(el) {
        $(el).LoadingOverlay("hide", {
            image: "",
            fontawesome: "fas fa-spinner fa-pulse"
        });
    }
});